/** @deprecated */
export const petriSpecs = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  CouponAlignmentInCartAndCheckout: 'specs.ecom.CouponAlignmentInCartAndCheckout',
  FixCartNavigationOnPreview: 'specs.ecom.FixCartNavigationOnPreview',
  RevampDiscountsInCartAndCheckout: 'specs.ecom.RevampDiscountsInCartAndCheckout',
  DontHandleCheckoutNotAllowedInCart: 'specs.ecom.DontHandleCheckoutNotAllowedInCart',
  UseLineItemDiscountInCartSummary: 'specs.ecom.UseLineItemDiscountInCartSummary',
  ShowAdditionalFeesInSideCart: 'specs.ecom.ShowAdditionalFeesInSideCart',
  DisplayCheckoutErrorModalsForExpressButtons: 'specs.ecom.DisplayCheckoutErrorModalsForExpressButtons',
  RemovePmNameErrorModal: 'specs.ecom.RemovePmNameErrorModal',
} as const;

export const conductorSpecs = {
  ecomInlineAddressSelectionInCart: 'ecomInlineAddressSelectionInCart',
  ecomCartLineItemUpsells: 'ecomCartLineItemUpsells',
  ecomCartSkeletonColor: 'ecomCartSkeletonColor',
  ecomShowTotalSavings: 'ecomShowTotalSavings',
  ecomShowReducedDiscountAmount: 'ecomShowReducedDiscountAmount',
  ecomShowEstimateDeliveryOnSubdivisionError: 'ecomShowEstimateDeliveryOnSubdivisionError',
  ecomShowFreeShippingCouponPlacementInCart: 'ecomShowFreeShippingCouponPlacementInCart',
  ecomPlanAndBookInPurchaseFlow: 'ecomPlanAndBookInPurchaseFlow',
  ecomCartNativeCssVars: 'ecomCartNativeCssVars',
} as const;

export const SPECS = {
  ...petriSpecs,
  ...conductorSpecs,
} as const;
